import { render, staticRenderFns } from "./AdmCommissionComponent.vue?vue&type=template&id=21e02a5c&"
import script from "./AdmCommissionComponent.vue?vue&type=script&lang=js&"
export * from "./AdmCommissionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports